import React, { useEffect, useState } from "react";
import {ChevronsUpDown, CreditCard, Download, EllipsisVertical, Loader, PrinterIcon, SquarePen, Trash2} from "lucide-react";
import { can_visit, exchangeDate, usDate } from "../../helpers";
import Badge from "../UI/Badge";
import DeleteModal from "../Modal/DeleteModal";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function InvoicesDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    handleFormView = () => {},
    handleFormPrint = () => {},
    invoiceEdit = () => {},
    handleDeleteInvoice = () => {},
    handlePayInvoice = () => {},
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [unpaidInvoiceLoader, setUnpaidInvoiceLoader] = useState(null);
  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  
  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };

  const LimitText = ({ text, limit }) => {
    if (text?.length <= limit) {
      return text;
    } else {
      const limitText = text?.substring(0, limit) + "...";
      return limitText;
    }
  };

  const payUnpaidInvoice = (id) => {
    setUnpaidInvoiceLoader(id);
    handlePayInvoice(id).finally(() => {
      setUnpaidInvoiceLoader(null);
    });
  }

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th style={{ width: '136px' }}>
                <div
                  onClick={() => { handleOrderChange("created_at"); }}
                  className={
                    orderBy === "created_at" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Invoice Date <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th style={{ width: '136px' }}>
                <div
                  onClick={() => { handleOrderChange("billing_date"); }}
                  className={
                    orderBy === "billing_date" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Billing Date <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("description"); }}
                  className={
                    orderBy === "description" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Description <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              {/* <th>Coding Done</th>
              <th>Charting Done</th> */}
              <th>
                <div
                  onClick={() => { handleOrderChange("amount_paid"); }}
                  className={
                    orderBy === "amount_paid" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Invoice Total <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("status"); }}
                  className={
                    orderBy === "status" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Status <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th className="text-right" style={{ width: '200px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
          {!dataLoading ? (
            tableData.length > 0 ? (
              tableData?.map((item, index) => (
                <tr key={index}>
                  <td className="pointer" onClick={() => handleFormView(item.id)}>{usDate(item?.created_at)}</td>
                  <td className="pointer" onClick={() => handleFormView(item.id)}>{item?.billing_date !== null ? exchangeDate(item?.billing_date) : "" }</td>
                  <td className="pointer" onClick={() => handleFormView(item.id)}>
                    {(item?.description && item?.description !== null) && (
                      <span className="docpro_mb_0 pointer docpro_icon_btn last_btn_tip overview" style={{ width: 'auto', height: 'auto', color: 'var(--primary)' }}>
                        <LimitText text={item?.description} limit={40} />
                        <div className="docpro_tip" style={{ maxWidth: '300px', whiteSpace: 'pre-wrap' }}>
                          <span>{item?.description}</span>
                        </div>
                      </span>
                    )}
                  </td>
                  {/* <td onClick={() => handleFormView(item.id)}>{item?.coding_done}</td>
                  <td onClick={() => handleFormView(item.id)}>
                    {item?.charting_done != null && (
                      <LimitText text={item?.charting_done} limit={20} />
                    )}
                  </td> */}
                  <td className="pointer" onClick={() => handleFormView(item.id)}>
                    {item?.amount_paid ? !isNaN(item?.amount_paid) ? `$${item.amount_paid.toFixed(2)}` : item?.amount_paid: ''}
                  </td>
                  <td className="pointer" onClick={() => handleFormView(item.id)}>
                    {item.status === "unpaid" && (
                      <Badge color="orange" square >Unpaid</Badge>
                    )}
                    {item.status === "paid" && (
                      <Badge color="green" square >Paid</Badge>
                    )}
                  </td>
                  <td className="docpro_text_center">
                    <div className="docpro_icon_btns" style={{ justifyContent: 'end', marginRight: '10px' }}>
                      {item.status === "paid" ?
                        <>
                          {item?.invoice_pdf !== null ? (
                            <a href={item?.invoice_pdf} download rel="noreferrer">
                              <button className="docpro_icon_btn">
                                <Download width={20} height={20} />
                                <span className="docpro_tip">Download</span>
                              </button>
                            </a>
                          ) : (
                            <button className="docpro_icon_btn"
                                onClick={() => handleFormPrint(item.id)}
                              >
                                <PrinterIcon width={20} height={20} />
                                <span className="docpro_tip">Print</span>
                              </button>
                          )}
                        </>
                      :
                        can_visit("administrator") ? (
                          <div className="dropdown-container relative">
                            <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                              <EllipsisVertical width={18} height={18} />
                            </button>
                            {viewStatusOptions[index] && (
                              <div className={`docpro_button_toggle_options ${index > 1 && 'top_position'}`}>
                                {/* <button className="docpro_icon_btn docpro_dropdown_button"
                                  onClick={() => invoiceEdit(item)}
                                >
                                  <SquarePen width={18} height={18} />
                                  <span>Edit</span>
                                </button> */}
                                {(can_visit("billing") && can_visit("billing_accept_and_pay")) && (
                                  <button 
                                    className="docpro_icon_btn docpro_dropdown_button"
                                    onClick={() => payUnpaidInvoice(item.id)}
                                    disabled={unpaidInvoiceLoader === item.id ? true : false}
                                  >
                                    <CreditCard width={18} height={18} />
                                    <span>Pay Now</span>
                                    {unpaidInvoiceLoader === item.id && (
                                      <span className="docpro_loading" style={{ background: '#00569ba3', color: '#FFF' }}>
                                        <Loader width={18} height={18} />
                                      </span>
                                    )}
                                  </button>
                                )}
                                {(can_visit("billing") && can_visit("billing_invoice_delete")) && (
                                  <button
                                    className="docpro_icon_btn docpro_dropdown_button docpro_icon_btn_red"
                                    onClick={() => {
                                      setDeleteRecord(item);
                                      setActiveDeleteModal(true);
                                      setPreviousScrollPosition(window.scrollY);
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    <Trash2 width={18} height={18} />
                                    <span>Delete</span>
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <button 
                            className="docpro_bordered_btn docpro_fw_500 docpro_white_color docpro_filed_btn"
                            onClick={() => payUnpaidInvoice(item.id)}
                            disabled={unpaidInvoiceLoader === item.id ? true : false}
                          >
                            <CreditCard width={20} height={20} />
                            <span>Pay Now</span>
                            {unpaidInvoiceLoader === item.id && (
                              <span className="docpro_loading">
                                <Loader width={20} height={20} />
                              </span>
                            )}
                          </button>
                        )
                      }
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="7">
                  No invoice found
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="7">
                Loading...
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
      {(activeDeleteModal && can_visit("billing_invoice_delete")) && (
        <DeleteModal
          handleDelete={() => handleDeleteInvoice(deleteRecord?.id)}
          name="this unpaid invoice"
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
